const getModuleState = state => state.groups;

export const userGroups = state => getModuleState(state).userGroups;

export const getGroupSearch = state => getModuleState(state).searchGroups;

export const getInviteDetails = state => getModuleState(state).inviteDetails;
